module.exports = __webpack_public_path__ + "static/media/profile_2.71ffe9bb.jpg";